module.exports = __webpack_public_path__ + "static/assets/b97e913ba34014c3a23026867ab23fb9.svg";